import * as Sentry from '@sentry/react';

const DSN = process.env.REACT_APP_SENTRY_DSN;

export function initSentry() {
  if (!DSN) return;
  try {
    Sentry.init({
      dsn: DSN,
      environment: process.env.NODE_ENV,
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 0,
    });
  } catch (_) {}
}

export function sentryIdentify(usuario) {
  if (!DSN || !usuario) return;
  try {
    Sentry.setUser({ id: usuario.id, email: usuario.email, username: usuario.nombre, rol: usuario.rol });
  } catch (_) {}
}

export function sentryReset() {
  if (!DSN) return;
  try { Sentry.setUser(null); } catch (_) {}
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;
